import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AgGridTemplateRendererComponent } from './ag-grid/cell-renderers/ag-grid-template-renderer.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridFitWidthDirective } from './ag-grid/directives/ag-grid-fit-width.directive';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridFilterTypeFilterComponent } from '@iris/common/modules/grid/ag-grid/components/ag-grid-filter/ag-grid-filter-type-filter.component';
import { IrisFieldsModule } from '@iris/common/modules/fields/fields.module';
import { AgGridFilterTemplateRendererComponent } from '@iris/common/modules/grid/ag-grid/components/ag-grid-filter-template-renderer/ag-grid-filter-template-renderer.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IrisCommonDirectivesModule } from '@iris/common/modules/directives-common/common-directives.module';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { IrisAgGridSelectorFloatingFilterComponent } from './ag-grid/components/ag-grid-selector-floating-filter/ag-grid-selector-floating-filter.component';
import { IrisAgGridFieldTextFloatingFilterComponent } from './ag-grid/components/ag-grid-field-text-floating-filter/ag-grid-field-text-floating-filter.component';
import { AgGridFixServerSortingModule } from '@iris/common/modules/grid/ag-grid/extensions/fix-server-sorting/fix-server-sorting.module';
import { AgGridPaginationModule } from '@iris/common/modules/grid/ag-grid/extensions/pagination/pagination.module';
import { AgGridQueryStateDirective } from './ag-grid/extensions/grid-request-state/grid-query-state.directive';
import { AgGridDirectivesModule } from '@iris/common/modules/grid/ag-grid/directives/ag-grid.directives.module';
import { AgGridClientPaginationModule } from '@iris/common/modules/grid/ag-grid/extensions/client-pagination/client-pagination.module';
import { IrisUserWSComponent } from '@iris/common/modules/user-common/modules/user-ws/components/user-ws.component';
import { StrakitSelectComponent, StrakitTextComponent } from '@ngx-strakit/cdk/controls';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    IrisUserWSComponent,
    IrisFieldsModule,
    MatMenuModule,
    MatDividerModule,
    MatCheckboxModule,
    IrisCommonDirectivesModule,
    MatButtonModule,
    MatSortModule,
    MatTooltipModule,
    InfiniteScrollDirective,
    AgGridFixServerSortingModule,
    AgGridPaginationModule,
    AgGridQueryStateDirective,
    AgGridDirectivesModule,
    AgGridClientPaginationModule,
    StrakitTextComponent,
    StrakitSelectComponent,
  ],
  declarations: [
    AgGridTemplateRendererComponent,
    AgGridFilterTypeFilterComponent,
    AgGridFilterTemplateRendererComponent,
    IrisAgGridSelectorFloatingFilterComponent,
    IrisAgGridFieldTextFloatingFilterComponent,
  ],
  exports: [
    AgGridModule,
    AgGridFitWidthDirective,
  ],
})
export class IrisGridModule {
  static forChild(): ModuleWithProviders<IrisGridModule> {
    return {
      ngModule: IrisGridModule,
    };
  }
}
